import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button, Modal } from 'react-bootstrap';
import { tail, compact, reduce } from 'lodash';
import Fa from 'react-fontawesome';
import { AgGridReact } from 'ag-grid-react';
import SearchField from '../../../../components/search-field';
import ProgressBar from '../../../../components/progress-bar';

import styles from './styles.css';

function NotFoundRenderer() {
  return (<div className="text-danger"><Fa name="exclamation-triangle" /> Not found</div>);
}

function FoundRenderer({ value }) {
  return (<div className="text-success"><Fa name="check-circle" /> {value || 'Imported'}</div>);
}

function KeywordRenderer({ value }) {
  return (<code>{value}</code>);
}

class ImportMemberModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      submitting: false,
      results: null,
      hasFileReader: typeof window.FileReader !== 'undefined',
    };
    this.close = this.close.bind(this);
    this.handleFileChange = this.handleFileChange.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.onGridReady = this.onGridReady.bind(this);
    this.ownerValueGetter = this.ownerValueGetter.bind(this);
    this.columnCellRendererSelector = this.columnCellRendererSelector.bind(this);
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.resizeColumns();
  }
  
  handleSearch(query) {
    if (this.gridApi) {
      this.gridApi.setQuickFilter(query);
    }
  }

  resizeColumns() {
    if (this.gridApi && this.gridColumnApi) {
      this.gridApi.sizeColumnsToFit();
    }
  }

  columnCellRendererSelector(params) {
    if (!params || !params.data) {
      return null;
    }
    if (!params.data.found) {
      return {
        component: NotFoundRenderer,
      };
    }
    return {
      component: FoundRenderer,
    };
  }


  ownerValueGetter(params) {
    const { data } = params;
    if (!data || !data.found) {
      return null;
    }
    return `${data.label}`;
  }

  close() {
    this.setState({ submitting: false, results: null });
    this.props.onClose();
  }

  handleFileChange(e) {
    if (this.state.submitting) {
      return;
    }
    this.setState({ submitting: true });
    const reader = new FileReader();
    reader.onload = () => {
      const content = reader.result ? reader.result.toString() : '';
      const data = compact(tail(content.split('\n')));
      const keywords = reduce(data, (items, datum) => {
        items.push(`${datum}`.trim().replace(/^\s+|\s+$|,/g, ''));
        return items;
      }, []);
      this.props.onImport(keywords)
        .then(
          (results) => {
            const resultData = reduce(results, (items, label, keyword) => {
              if (label) {
                items.push({ keyword, label, found: true });
              } else {
                items.push({ keyword, found: false });
              }
              return items;
            }, []);
            console.log('resultData', resultData)
            this.setState({ results: resultData }, () => {
              this.resizeColumns();
            });
          },
          (e) => {

          },
        );
    };
    reader.readAsBinaryString(e.target.files[0]);
  }

  renderResults() {
    const { results } = this.state;
    const showPagination = results && results.length > 15;

    const columnDefs = [
      {
        headerName: 'Input',
        field: 'keyword',
        colId: 'keyword',
        pinned: 'left',
        suppressMenu: true,
        suppressMovable: true,
        suppressColumnsToolPanel: true,
        suppressFiltersToolPanel: true,
        cellRenderer: KeywordRenderer,
      },
      {
        headerName: 'Status',
        colId: 'status',
        field: 'label',
        suppressMenu: true,
        suppressMovable: true,
        suppressColumnsToolPanel: true,
        suppressFiltersToolPanel: true,
        cellRendererSelector: this.columnCellRendererSelector,
        width: 250,
        valueGetter: this.ownerValueGetter,
      },
    ];

    return (
      <div>
        {showPagination &&
          <nav className="navbar navbar-default navbar-controls">
            <form className="navbar-form navbar-left">
              <SearchField collapsible={false} onSearch={this.handleSearch} />
            </form>
          </nav>
        }
        <div className="ag-theme-alpine" style={{ width: '100%' }}>
          <AgGridReact
            reactNext
            enableColResize
            enableSorting
            animateRows
            domLayout="autoHeight"
            suppressColumnVirtualisation
            columnDefs={columnDefs}
            pagination={showPagination}
            paginationPageSize={15}
            onGridReady={this.onGridReady}
            rowData={results}
          />
        </div>
      </div>
    );
  }

  render() {
    const {
      submitting,
      hasFileReader,
      results,
    } = this.state;
    const { open, isUserMapping } = this.props;

    if (!hasFileReader) {
      return null;
    }

    const hasResults = results !== null;

    return (
      <Modal show={open} onHide={this.close} keyboard={false} bsSize='lg'>
        <Modal.Header closeButton>
          <Modal.Title>Import Mapping Value</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {hasResults && this.renderResults()}
          {!hasResults &&
            <div>
              {!submitting &&
                <div>
                  {isUserMapping &&
                    <div className="well">
                      <p>Import user mappings using an Excel CSV file.</p>
                      <p>
                        You can <span className={styles.uploader}><a href="">upload</a><input accept=".csv" disabled={submitting} id="csv" type="file" onChange={this.handleFileChange} /></span> an <code>.csv</code>
                        {' '}
                        file that contains the sales reps&rsquo; emails or User Id.
                      </p>
                      <p><a href="/assets/sample.csv" target="_blank">Click here</a> to download a sample <code>.csv</code> file.</p>
                    </div>
                  }
                  {!isUserMapping &&
                    <div className="well">
                      <p>Import mapping values using an Excel CSV file.</p>
                      <p>
                        You can <span className={styles.uploader}><a href="">upload</a><input accept=".csv" disabled={submitting} id="csv" type="file" onChange={this.handleFileChange} /></span> an <code>.csv</code>
                        {' '} file.
                      </p>
                      <p><a href="/assets/sample.csv" target="_blank">Click here</a> to download a sample <code>.csv</code> file.</p>
                    </div>
                  }
                </div>
              }
              {submitting &&
                <div><ProgressBar /><p /></div>
              }
            </div>
          }
        </Modal.Body>
        <Modal.Footer>
          <div className='clearfix'>
            <Button
              bsStyle='link'
              onClick={this.close}
              disabled={submitting && !hasResults}
            >
              {hasResults ? 'Done' : 'Cancel'}
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    )
  }
}

// Retrieve data from store as props
function mapStateToProps() {
  return {
  };
}

ImportMemberModal.propTypes = {
  dispatch: PropTypes.func.isRequired,
  onClose: PropTypes.func,
  open: PropTypes.bool,
  isUserMapping: PropTypes.bool,
  filter: PropTypes.shape({

  }).isRequired,
  onImport: PropTypes.func,
};

ImportMemberModal.defaultProps = {
  onClose: () => {},
  open: false,
  isUserMapping: false,
  onImport: () => Promise.reject(new Error('need handler')),
};

export default connect(mapStateToProps)(ImportMemberModal);
